module.exports = __webpack_public_path__ + "img/klarna_popup.8b9246eb.gif";